// pages/+onBeforeRoute.ts
// Environment: server & client

import type { PageContext } from 'vike/types'
import { modifyUrl } from 'vike/modifyUrl'
import type { Url } from 'vike/types'
import { DEFAULT_LOCALE } from '@/modules/i18n'

export function onBeforeRoute(pageContext: PageContext) {
  const { urlWithoutLocale, locale } = extractLocale(pageContext.urlParsed)
  return {
    pageContext: {
      // Make locale available as pageContext.locale
      locale,
      // Vike's router will use pageContext.urlLogical instead of pageContext.urlOriginal and
      // the locale is removed from pageContext.urlParsed
      urlLogical: urlWithoutLocale
    }
  }
}

function extractLocale(url: Url) {
  // const { pathname } = url

  // Determine the locale, for example:
  //  /en-US/film/42 => en-US
  //  /de-DE/film/42 => de-DE
  const locale = DEFAULT_LOCALE

  // Remove the locale, for example:
  //  /en-US/film/42 => /film/42
  //  /de-DE/film/42 => /film/42
  const pathnameWithoutLocale = url.pathname

  // Reconstruct full URL
  const urlWithoutLocale = modifyUrl(url.pathname, { pathname: pathnameWithoutLocale })

  return { locale, urlWithoutLocale }
}
